module.exports = __webpack_public_path__ + "static/media/52.7fe88e31.png";